import { inject } from '@angular/core';
import { GROUNDWORKS_DEFAULT_TENANT_ID, GroundworksAuthConfig } from '@groundworks/ngx-groundworks-auth';
import { ConfigService } from './services/config.service';
import { ProfileService } from './services/profile.service';

export function buildGroundworksAuthConfig(config: ConfigService): GroundworksAuthConfig {
  const graphUri = config.graph.uri.trim();
  const graph = {
    uri: graphUri === '' || graphUri.endsWith('*') ? graphUri : `${graphUri}*`,
    scopes: config.graph.scopes,
  };
  const graphConfigured = graph.uri !== '' && graph.scopes.length > 0;
  if (!graphConfigured && (graph.uri !== '' || graph.scopes.length > 0)) {
    console.warn('[auth.config] graph_uri and graph_scopes must both be set; Graph is not protected.');
  }

  return {
    clientId: config.clientId,
    tenantId: GROUNDWORKS_DEFAULT_TENANT_ID,
    redirectUri: config.authRedirectUrl.trim(),
    apiUrl: resolveApiUrl(config),
    production: Boolean(config.production),
    ...(graphConfigured ? { graph } : {}),
    hooks: {
      afterInteractionComplete: (account) =>
        account.idTokenClaims ? inject(ProfileService).initialize() : undefined,
    },
  };
}

export function resolveApiUrl(config: ConfigService): string {
  return (config.apiUrl.trim() || window.location.origin).replace(/\/+$/, '');
}
